import Banner from "../components/blogs/blogBanner";
import BlogLayout from "../components/blogs/layout";

const Blogs =()=>{
    return (<>
        <Banner/>
        <BlogLayout/>
    </>
    )
}

export default Blogs;